import { styled, Text, TextTag } from "@volkswagen-onehub/components-core";
import { FinanceProviderState } from "@volkswagen-onehub/finance-integration-service-types";
import { CAFinanceProviderState, PaymentType } from "@vw-marketing/vw-ca-types";
import React from "react";
import { DisclaimerMarker } from "../../../../components/DisclaimerMarker";
import { useFinanceStore } from "../../../../store/estimates/finance";
import { getLang, getTranslations } from "../../../../translations";
import { Language } from "../../../../types";
import { formatCurrency } from "../../../../utils/format";
import { getDisclaimerNumber } from "../../../../utils/get-disclaimer-number";

const StyledLine = styled(Text)`
  display: flex;
  justify-content: space-between;
`;

export default () => {
  const lang = getLang() as Language;
  const { financeData } = useFinanceStore();
  const { labels } = getTranslations();

  if (!financeData || Object.keys(financeData).length < 1) return null;

  const {
    downPayment,
    tradeValue,
    financeTerm,
    leaseTerm,
    cost_summary,
    selectedPaymentType,
    disclaimers,
    financeBreakdownHeadline
  } = financeData as FinanceProviderState<CAFinanceProviderState>;

  let total_price;
  let payment_amount;
  let term;

  if (cost_summary && selectedPaymentType) {
    payment_amount = cost_summary[selectedPaymentType]?.find(item => item.key === "payment_amount")?.full_string_value;
    total_price = cost_summary[selectedPaymentType]?.find(item => item.key === "total_price")?.full_string_value;
  }

  if (selectedPaymentType === PaymentType.FINANCE) {
    term = financeTerm;
  } else if (selectedPaymentType === PaymentType.LEASE) {
    term = leaseTerm;
  } else {
    term = null;
  }

  return (
    <div aria-live="polite">
        <StyledLine bold>
          <Text tag={TextTag.span}>{ financeBreakdownHeadline }</Text>
          { payment_amount
            ? <Text tag={TextTag.span}>
                { payment_amount }
                <DisclaimerMarker
                  marker={getDisclaimerNumber("calculation") || ""}
                  text={disclaimers.calculation as string}
                  id="cash"
                />
                <DisclaimerMarker
                  marker={getDisclaimerNumber("product") || ""}
                  text={disclaimers.product as string}
                  id="finance-lease"
                />
              </Text>
            : <Text tag={TextTag.span}>
              { total_price }
              <DisclaimerMarker
                marker={getDisclaimerNumber("calculation") || ""}
                text={disclaimers.calculation as string}
                id="cash"
              />
              <DisclaimerMarker
                marker={getDisclaimerNumber("product") || ""}
                text={disclaimers.product as string}
                id="finance-lease"
              />
            </Text>
          }
        </StyledLine>
        {
          term
          ? <StyledLine>
            <Text tag={TextTag.span}>{ labels.term }</Text>
            <Text tag={TextTag.span}>{ labels.term_months.replace("[term]", term) }</Text>
          </StyledLine>
          : null
        }
        {
          tradeValue
          ? <StyledLine>
            <Text tag={TextTag.span}>{ labels.tradein_value }</Text>
            <Text tag={TextTag.span}>{ formatCurrency(tradeValue, true, lang) }</Text>
            </StyledLine>
          : null
        }
        {
          downPayment
          ? <StyledLine>
            <Text tag={TextTag.span}>{ labels.down_payment }</Text>
            <Text tag={TextTag.span}>{ formatCurrency(downPayment, true, lang) }</Text>
          </StyledLine>
          : null
        }
    </div>
  );
}
